import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-create-inv',
  templateUrl: './create-inv.component.html',
  styleUrls: ['./create-inv.component.scss']
})
export class CreateInvComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
